module.exports = __webpack_public_path__ + "img/aptitude26.fd5d07ff.jpg";